import * as React from "react";
import { cn } from "@/utils/common.utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, onKeyDown, ...props }, ref) => (
  <input
    type={type}
    onKeyDown={(event) => {
      if (type === "number" && ["e", "E", "+", "-"].includes(event.key)) {
        event.preventDefault();
      }
      onKeyDown?.(event);
    }}
    className={cn(
      "flex h-10 w-full rounded-xl border border-dash-border bg-white px-3 py-2 text-sm text-dash-ink shadow-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-dash-ink placeholder:text-dash-faint focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    ref={ref}
    {...props}
  />
));
Input.displayName = "Input";

export { Input };
